/* Landing cobija — JS extraído de la fuente.
   Lo carga layout/landing.liquid (case 'cobija'). */


(function(){
  var cop = function(n){ return '$' + n.toLocaleString('es-CO'); };

  var galMain = document.getElementById('galMain');
  function setMain(src){
    if (!src || !galMain) return;
    galMain.src = src;
    document.querySelectorAll('.thumb').forEach(function(t){
      t.classList.toggle('on', t.dataset.src === src);
    });
  }

  // --- thumbs ---
  document.querySelectorAll('.thumb').forEach(function(t){
    t.addEventListener('click', function(){ setMain(t.dataset.src); });
  });

  // --- diseños: al elegir uno, la galería lo muestra en la cama ---
  document.querySelectorAll('.chip').forEach(function(c){
    c.addEventListener('click', function(){
      document.querySelectorAll('.chip').forEach(function(x){ x.classList.remove('on'); });
      c.classList.add('on');
      setMain(c.dataset.src);
    });
  });

  // --- bundles ---
  var pNow  = document.getElementById('pNow'),
      pOld  = document.getElementById('pOld'),
      pSave = document.getElementById('pSave'),
      sNow  = document.getElementById('sNow'),
      sOld  = document.getElementById('sOld'),
      sQty  = document.getElementById('sQty');

  document.querySelectorAll('.bundle').forEach(function(b){
    b.addEventListener('click', function(){
      document.querySelectorAll('.bundle').forEach(function(x){ x.classList.remove('on'); });
      b.classList.add('on');
      var now  = +b.dataset.now,
          old  = +b.dataset.old,
          save = +b.dataset.save,
          qty  = +b.dataset.qty,
          unit = b.dataset.unit;

      pNow.textContent  = cop(now);
      pOld.textContent  = cop(old);
      pSave.textContent = 'Ahorras ' + cop(save);
      sNow.textContent  = cop(now);
      sOld.textContent  = cop(old);
      sQty.textContent  = qty + (qty === 1 ? ' cobija' : ' cobijas') + (unit ? ' · ' + unit : '');
    });
  });
})();

/* ============================================================
   Releasit COD — variante activa + cantidad + disparo del modal
   Lo genera tools/apply_cod_trigger.py desde tools/cod_trigger.js.tpl.

   PATRÓN (memoria project-northpower-landing / project-diosa-landing):
   NO se crean variantes-bundle. Dropi solo despacha las variantes que
   mapeó al IMPORTAR el producto; una variante creada después por API
   queda huérfana y el pedido no le llega (bug NorthPower #1019).
   Por eso el bundle es la MISMA variante de Dropi con quantity = N, y el
   total lo baja un descuento automático de Shopify (mín. N unidades).
   Así el pedido lleva las unidades físicas reales y Dropi las despacha.

   Releasit lee la cantidad de input[name="quantity"] en el DOM al abrir,
   y la variante de window.productData — pero SOLO la re-lee si se hace
   click en su botón nativo. _rsiV2.setState abre el modal con la variante
   cacheada al init, así que queda como último recurso.
   Depende de quantityControlsHidden:true en Releasit (ya global): si el
   cliente pudiera bajar la cantidad, pagaría el precio con descuento por
   menos unidades.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
      i.setAttribute('value', variantId);
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* Qué variante y qué cantidad está eligiendo el cliente ahora mismo.
     Siempre se lee del DOM — nunca del SKU, que Dropi reescribe. */
  /* Dos ejes: el diseño (variante real de Shopify, 1:1 con las 10 de Dropi)
     y la cantidad (misma variante, quantity N + descuento automático). */
  function current() {
    var chip = document.querySelector('.cobija-landing .chip.on')
            || document.querySelector('.cobija-landing .chip');
    var card = document.querySelector('.cobija-landing .bundle.on')
            || document.querySelector('.cobija-landing .bundle');
    var map = window.COBIJA_VARIANTS || {};
    var name = chip ? chip.getAttribute('data-diseno') : null;
    return {
      id: map[name] || map[Object.keys(map)[0]],
      qty: card ? (parseInt(card.getAttribute('data-bundle-qty'), 10) || 1) : 1
    };
  }

  function sync() {
    var s = current();
    if (s && s.id) setVariantOnAllForms(s.id, s.qty);
    return s;
  }

  // el JS de la landing ya mueve la clase activa; aquí solo re-leemos después
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.chip, .bundle')) {
      setTimeout(sync, 0);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', sync);
  sync();

  window.cobijaTriggerCOD = function () {
    var s = sync();
    if (!s || !s.id) return;
    setTimeout(function () {
      var b0 = findReleasitButton();
      if (b0) { b0.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
